import { render, staticRenderFns } from "./EditableTemplatePost.vue?vue&type=template&id=64d7092e&scoped=true&"
import script from "./EditableTemplatePost.vue?vue&type=script&lang=js&"
export * from "./EditableTemplatePost.vue?vue&type=script&lang=js&"
import style0 from "./EditableTemplatePost.vue?vue&type=style&index=0&id=64d7092e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d7092e",
  null
  
)

export default component.exports